export default __webpack_public_path__ + "static/media/EnabilDec.2dd888e8.svg";